import React from 'react';
import {compose, graphql} from 'react-apollo';

import Catalogue from './Catalogue';
import Loading from "components/Loading";

import {withOperator} from 'helpers/operator';
import {withOperatorAds} from 'helpers/operatorAds';
import PropTypes from "prop-types";
import moment from "moment/moment";

import CatalogueQuery from 'gql/catalogue.gql';

import {defineMessages, injectIntl} from "react-intl";

import {requireLoggedUser} from "helpers/login";

const messages = defineMessages({
    all_ads: {
        id: "catalogue.all_ads",
        defaultMessage: "All ads"
    }
});

class CatalogueProvider extends React.Component {
    static propTypes = {
        catalogueQuery: PropTypes.object.isRequired,
        operator: PropTypes.object.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        onLogout: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.changeSearchTerm = this.changeSearchTerm.bind(this);
        this.changeSearchOnlyAd = this.changeSearchOnlyAd.bind(this);
        this.changeDateFrom = this.changeDateFrom.bind(this);
        this.changeDateTo = this.changeDateTo.bind(this);
    }

    componentWillMount() {
        this.setState({
            limit: 25,
            searchTerm: '',
            ad: null,
            categories: [],
            dateFrom: moment().endOf('day').subtract(1, "months"),
            dateTo: moment().endOf('day')
        })
    }

    changeSearchTerm(event) {
        const searchTerm = event.target.value;

        this.setState({
            searchTerm
        }, this.refetchData);
    }

    changeSearchOnlyAd(ad) {
        this.setState({
            ad
        }, this.refetchData);
    }

    changeDateFrom(date) {
        date.startOf('day');
        this.setState({
            dateFrom: date,
        }, this.refetchData);
    }

    changeDateTo(date) {
        this.setState({
            dateTo: date,
        }, this.refetchData);
    }

    refetchData() {
        this.props.catalogueQuery.refetch({
            limit: this.state.limit,
            ad: this.state.ad,
            searchTerm: this.state.searchTerm,
            dateFrom: this.state.dateFrom.unix(),
            dateTo: this.state.dateTo.unix(),
            categories: this.state.categories,
        });
    }

    render() {
        const {catalogueQuery, operator, operatorAds, onOnlineChange, onLogout, intl} = this.props;
        const {searchTerm, ad, dateFrom, dateTo} = this.state;

        if (catalogueQuery.loading && !searchTerm) {
            return <Loading/>
        }

        let contacts = [];
        let totalContacts = 0;
        if (catalogueQuery.searchContacts) {
            contacts = catalogueQuery.searchContacts;
        }
        if (catalogueQuery.countContacts) {
            totalContacts = catalogueQuery.countContacts;
        }

        let availableAds = [];
        if (operatorAds) {
            availableAds = operatorAds.map(ad => ({
                name: ad.heading,
                value: ad.id.toString()
            }));

            // The first element empty
            availableAds.unshift({
                name: intl.formatMessage(messages.all_ads),
                value: ''
            });
        }

        return <Catalogue operator={operator} searchTerm={searchTerm} availableAds={availableAds} ad={ad}
                          dateFrom={dateFrom} dateTo={dateTo} contacts={contacts}
                          totalContacts={totalContacts} onOnlineChange={onOnlineChange} onLogout={onLogout}
                          onChangeSearchTerm={this.changeSearchTerm} onChangeSearchOnlyAd={this.changeSearchOnlyAd}
                          onChangeDateFrom={this.changeDateFrom} onChangeDateTo={this.changeDateTo} onLoadMoreContacts={catalogueQuery.loadMoreContacts}
         />
    }
}

export default compose(
    injectIntl,
    requireLoggedUser,
    withOperator,
    withOperatorAds,
    graphql(CatalogueQuery, {
        name: 'catalogueQuery',
        options: props => ({
            variables: {
                limit: 25,
                searchTerm: '',
                dateTo: moment().endOf('day').unix(),
                dateFrom: moment().startOf('day').subtract(1, "months").unix(),
                categories: []
            },
            fetchPolicy: 'network-only'
        }),
        props({catalogueQuery: {searchContacts, fetchMore, ...rest}}) {
            return {
                catalogueQuery: {
                    searchContacts,
                    ...rest,
                    loadMoreContacts() {
                        return fetchMore({
                            variables: {
                                offset: searchContacts.length,
                            },
                            updateQuery: (previousResult, {fetchMoreResult}) => {
                                if (!fetchMoreResult) {
                                    return previousResult;
                                }
                                const newContacts = [...previousResult.searchContacts, ...fetchMoreResult.searchContacts];
                                return Object.assign({}, previousResult, {searchContacts: newContacts});
                            }
                        })
                    }
                }
            }
        }

    })
)(CatalogueProvider);


// WEBPACK FOOTER //
// ./src/containers/Catalogue/index.jsx